import PropTypes from 'prop-types';
import FeaturedImageShape from '@/shapes/FeaturedImage';
import {
  trainerInfoDefaultProps,
  trainerInfoPropTypes,
} from './TrainerInfoShape';
import {
  trainerSocialDefaultProps,
  trainerSocialPropTypes,
} from './TrainerSocialShape';

const defaultProps = {
  info: trainerInfoDefaultProps,
  social: trainerSocialDefaultProps,
};

const propTypes = {
  title: PropTypes.string,
  featuredImage: FeaturedImageShape,
  info: PropTypes.shape(trainerInfoPropTypes),
  social: PropTypes.shape(trainerSocialPropTypes),
};

export { defaultProps as trainerDefaultProps, propTypes as trainerPropTypes };
